<a [attr.href]="to ? to : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="base-card -title-container">
    <ng-container *ngIf="icon">
      <ng-container *ngIf="icontype === 'lucide'; else defaultIcon">
        <lucide-icon [name]="icon"></lucide-icon>
      </ng-container>
      <ng-template #defaultIcon>
        <icon [icon]="icon" [class]="iconsize + ' ' + iconcolor"></icon>
      </ng-template>
    </ng-container>
    <h3 class="mt-0">{{title}}</h3>
  </div>
  <ng-content></ng-content>
</a>